<template>
  <section
    ref="fullscreenRoot"
    class="data-board"
    :class="{ 'is-fullscreen': isFullscreen }"
    aria-label="福建通文产业服务有限公司数据看板"
  >
    <div
      ref="boardShell"
      class="board-shell"
      :class="{ 'is-fullscreen': isFullscreen }"
      :style="fullscreenShellStyle"
    >
      <button
        type="button"
        class="board-fullscreen-toggle"
        :aria-label="isFullscreen ? '退出全屏展示' : '全屏展示数据看板'"
        :title="isFullscreen ? '退出全屏' : '全屏展示'"
        @click="toggleFullscreen"
      >
        <i
          :class="isFullscreen ? 'el-icon-close' : 'el-icon-full-screen'"
          aria-hidden="true"
        ></i>
      </button>
      <header class="board-heading">
        <p class="heading-kicker">高质量就业服务 促进高质量就业</p>
        <p class="stat-period">统计周期：{{ board.statPeriod }}</p>
      </header>

      <div class="summary-panel">
        <span v-for="(item, index) in summaryItems" :key="item.code || index">
          {{ item.title }}<strong>{{ item.value }}</strong
          >{{ item.unit }}
        </span>
      </div>

      <main class="card-grid" :style="fullscreenGridStyle">
        <article
          v-for="card in cards"
          :key="card.code || card.number"
          class="data-card"
        >
          <div class="card-title">
            <span class="card-number">{{ card.number }}</span>
            <h3>{{ card.title }}</h3>
          </div>
          <div class="card-body">
            <ul class="data-list">
              <li
                v-for="(line, index) in card.lines"
                :key="index"
                :class="{ 'is-wide': isWideLine(line) }"
                v-html="line"
              ></li>
            </ul>
          </div>
        </article>
      </main>
    </div>
  </section>
</template>

<script>
import { getDataBoard } from '@/api/home/home.js'

const CARD_ITEM_GROUPS = {
  integration: [[0], [1], [2], [3]],
  enterprise: [[0], [1], [2], [3]],
  cultivation: [[0], [1], [2], [3], [4]],
  event: [[0], [1], [2], [3]],
  base: [[0], [1], [2], [3]],
  employment: [[0], [1], [2], [3]],
  visit: [[0], [1], [2], [3]],
  collaboration: [[0], [1], [2], [3], [4]]
}

export default {
  name: 'DataBoard',
  data() {
    return {
      isFullscreen: false,
      refreshTimer: null,
      pageScaleStyles: null,
      fullscreenBaseHeight: 760,
      fullscreenBaseWidth: 1340,
      fullscreenScale: 1,
      fullscreenScaleX: 1,
      fullscreenScaleY: 1,
      board: {
        title: '福建通文产业服务有限公司数据看板',
        statPeriod: '2022年1月至今',
        summaryItems: [
          { title: '园区', value: '3', unit: '个' },
          { title: '服务高校', value: '32', unit: '所' },
          { title: '服务企业', value: '3200', unit: '家' },
          { title: '实训面积', value: '12000', unit: 'm²' },
          { title: '参赛', value: '15.6', unit: '人次' },
          { title: '输送人才', value: '2680', unit: '人' }
        ],
        cards: [
          {
            number: 1,
            title: '园区管理',
            lines: [
              '<b>3</b>个园区（集美区人力资源服务产业园）',
              '集美高新人力资源服务产业园',
              '同安青年创新创业基地',
              '入驻人才服务机构 <b>132</b>家'
            ]
          },
          {
            number: 2,
            title: '产教融合',
            lines: [
              '服务高校<b>32</b>所',
              '实践实训 <b>28500</b>人次',
              '人校活动<b>253</b>场',
              '参赛学生<b>85000</b>人次'
            ]
          },
          {
            number: 3,
            title: '服务企业',
            lines: [
              '服务企业<b>3200</b>家',
              '输送人才<b>2680</b>人',
              '职场体验日<b>153</b>场',
              '校企对接<b>67</b>场'
            ]
          },
          {
            number: 4,
            title: '人才培养',
            lines: [
              '数字经济人才<b>685</b>人',
              '智能制造人才<b>852</b>人',
              '智能制造实训<b>18400</b>人次',
              '应急安全人才<b>7500</b>人',
              '开设课程<b>62</b>门'
            ]
          },
          {
            number: 5,
            title: '赛事活动',
            lines: [
              '举办赛事<b>8</b>场',
              '参赛院校<b>133</b>个',
              '参赛项目<b>2158</b>个',
              '参赛人数 <b>155243</b>人次'
            ]
          },
          {
            number: 6,
            title: '基地建设',
            lines: [
              '实训室<b>21</b>个',
              '设备投入<b>1320</b>万元',
              '实训场地<b>12000</b>平方米',
              '专兼职教师<b>263</b>人'
            ]
          },
          {
            number: 7,
            title: '就业服务',
            lines: [
              '此板块必要完善暂时显示',
              '举办招聘会<b>38</b>场',
              '参加院校<b>26</b>所',
              '参加企业<b>932</b>家',
              '参加人次<b>45452</b>人次'
            ]
          },
          {
            number: 8,
            title: '考察交流',
            lines: [
              '外出考察<b>63</b>次',
              '政府考察<b>2633</b>人次',
              '高校交流<b>1598</b>人次',
              '企业交流<b>5632</b>人次'
            ]
          },
          {
            number: 9,
            title: '协同育人',
            lines: [
              '用工联合体<b>352</b>家',
              '培训联合体<b>36</b>家',
              '创新联合体<b>58</b>个',
              '劳务协作<b>5</b>个',
              '贵州省贵州 <b>41</b>个招聘点'
            ]
          }
        ]
      }
    }
  },
  computed: {
    summaryItems() {
      return this.sortItems(this.board.summaryItems)
    },
    cards() {
      return this.sortItems(this.board.cards).map((card, index) => ({
        ...card,
        number: index + 1,
        lines: Array.isArray(card.lines) ? card.lines : this.cardLines(card)
      }))
    },
    fullscreenShellStyle() {
      if (!this.isFullscreen) return {}
      return {
        height: this.fullscreenBaseHeight + 'px',
        left: '50%',
        position: 'absolute',
        top: '50%',
        transform:
          'translate(-50%, -50%) scale(' +
          this.fullscreenScaleX +
          ', ' +
          this.fullscreenScaleY +
          ')',
        transformOrigin: 'center center',
        width: this.fullscreenBaseWidth + 'px'
      }
    },
    fullscreenGridStyle() {
      return {}
    }
  },
  created() {
    this.fetchDataBoard()
  },
  mounted() {
    document.addEventListener('fullscreenchange', this.syncFullscreenState)
    document.addEventListener(
      'webkitfullscreenchange',
      this.syncFullscreenState
    )
    window.addEventListener('resize', this.updateFullscreenScale)
  },
  beforeDestroy() {
    document.removeEventListener('fullscreenchange', this.syncFullscreenState)
    document.removeEventListener(
      'webkitfullscreenchange',
      this.syncFullscreenState
    )
    window.removeEventListener('resize', this.updateFullscreenScale)
    this.stopFullscreenRefresh()
    this.restorePageScale()
  },
  methods: {
    toggleFullscreen() {
      if (this.isFullscreen) {
        const exit = document.exitFullscreen || document.webkitExitFullscreen
        if (exit) exit.call(document)
        return
      }
      const element = this.$refs.fullscreenRoot
      const request =
        element &&
        (element.requestFullscreen || element.webkitRequestFullscreen)
      if (request) {
        this.captureBoardSize()
        this.disablePageScale()
        const result = request.call(element)
        if (result && result.catch) result.catch(() => this.restorePageScale())
      }
    },
    syncFullscreenState() {
      this.isFullscreen =
        document.fullscreenElement === this.$refs.fullscreenRoot ||
        document.webkitFullscreenElement === this.$refs.fullscreenRoot
      this.updateFullscreenScale()
      if (this.isFullscreen) {
        this.startFullscreenRefresh()
      } else {
        this.stopFullscreenRefresh()
        this.restorePageScale()
      }
    },
    startFullscreenRefresh() {
      this.stopFullscreenRefresh()
      this.fetchDataBoard().then(() => this.scheduleFullscreenRefresh())
    },
    scheduleFullscreenRefresh() {
      if (!this.isFullscreen) return
      this.refreshTimer = window.setTimeout(() => {
        this.fetchDataBoard().then(() => this.scheduleFullscreenRefresh())
      }, 10000)
    },
    stopFullscreenRefresh() {
      if (this.refreshTimer) {
        window.clearTimeout(this.refreshTimer)
        this.refreshTimer = null
      }
    },
    updateFullscreenScale() {
      if (!this.isFullscreen) {
        this.fullscreenScale = 1
        this.fullscreenScaleX = 1
        this.fullscreenScaleY = 1
        return
      }
      this.fullscreenScaleX = window.innerWidth / this.fullscreenBaseWidth
      this.fullscreenScaleY = window.innerHeight / this.fullscreenBaseHeight
      this.fullscreenScale = Math.min(
        this.fullscreenScaleX,
        this.fullscreenScaleY
      )
    },
    captureBoardSize() {
      const board = this.$refs.boardShell
      if (!board) return
      this.fullscreenBaseWidth = board.offsetWidth || 1340
      this.fullscreenBaseHeight = board.offsetHeight || 760
    },
    disablePageScale() {
      if (this.pageScaleStyles) return
      const style = document.body.style
      this.pageScaleStyles = {
        transform: style.transform,
        transformOrigin: style.transformOrigin,
        width: style.width,
        zoom: style.zoom
      }
      document.documentElement.classList.add('data-board-fullscreen-active')
      style.zoom = '1'
      style.transform = 'none'
      style.transformOrigin = ''
      style.width = '100%'
    },
    restorePageScale() {
      if (!this.pageScaleStyles) return
      const style = document.body.style
      style.zoom = this.pageScaleStyles.zoom
      style.transform = this.pageScaleStyles.transform
      style.transformOrigin = this.pageScaleStyles.transformOrigin
      style.width = this.pageScaleStyles.width
      document.documentElement.classList.remove('data-board-fullscreen-active')
      this.pageScaleStyles = null
      window.dispatchEvent(new Event('resize'))
    },
    fetchDataBoard() {
      return getDataBoard()
        .then((res) => {
          if (res && res.data && Array.isArray(res.data.cards)) {
            this.board = res.data
          }
        })
        .catch(() => {})
    },
    sortItems(items) {
      return Array.isArray(items)
        ? items.slice().sort((a, b) => (a.sortNo || 0) - (b.sortNo || 0))
        : []
    },
    cardLines(card) {
      const items = Array.isArray(card.items) ? card.items : []
      const texts = Array.isArray(card.texts) ? card.texts : []
      const lines = texts.map((text) => this.escapeHtml(text))
      const itemLines = items.map((item) => this.formatItem(card, item))
      return card.code === 'park' && itemLines.length
        ? [itemLines[0], ...lines, ...itemLines.slice(1)]
        : [...lines, ...this.groupItemLines(card, itemLines)]
    },
    groupItemLines(card, itemLines) {
      const groups = CARD_ITEM_GROUPS[card.code]
      if (!groups) return itemLines
      return groups
        .map((group) =>
          group
            .map((index) => itemLines[index])
            .filter(Boolean)
            .join('、')
        )
        .filter(Boolean)
    },
    formatItem(card, item) {
      const title = this.escapeHtml(item.title || '')
      const value = '<b>' + this.escapeHtml(item.value || '') + '</b>'
      const unit = this.escapeHtml(item.unit || '')
      if (card.code === 'park' && item.title === '园区') {
        return value + unit + title + '（集美区人力资源服务产业园）'
      }
      return title + value + unit
    },
    isWideLine(line) {
      return String(line).replace(/<[^>]*>/g, '').length > 11
    },
    escapeHtml(value) {
      return String(value == null ? '' : value).replace(
        /[&<>"']/g,
        (character) =>
          ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
          }[character])
      )
    }
  }
}
</script>

<style scoped lang="scss">
.data-board {
  --cyan: #38f5ff;
  box-sizing: border-box;
  color: #e8faff;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  padding: 22px 0;
  position: relative;
  width: 100%;
}
.data-board.is-fullscreen,
.data-board:fullscreen,
.data-board:-webkit-full-screen {
  background: #030a31;
  height: 100vh;
  overflow: hidden;
  padding: 0;
  width: 100vw;
}

.board-shell {
  background: radial-gradient(
      ellipse 55% 30% at 50% 100%,
      rgba(19, 146, 255, 0.42),
      transparent 72%
    ),
    radial-gradient(
      ellipse 32% 42% at 0 48%,
      rgba(72, 35, 184, 0.38),
      transparent 74%
    ),
    radial-gradient(
      ellipse 32% 42% at 100% 48%,
      rgba(72, 35, 184, 0.38),
      transparent 74%
    ),
    linear-gradient(
      180deg,
      rgba(2, 8, 39, 0.62),
      rgba(2, 15, 68, 0.12) 20%,
      rgba(1, 15, 72, 0.2) 82%,
      rgba(18, 17, 101, 0.52)
    ),
    #030a31 url('~@/assets/images/data-board-background.png') center / cover
      no-repeat;
  border: 1px solid rgba(42, 221, 255, 0.78);
  border-radius: 18px;
  box-shadow: 0 0 32px rgba(25, 68, 255, 0.34),
    inset 0 0 46px rgba(10, 87, 204, 0.3);
  box-sizing: border-box;
  margin: 0 auto;
  max-width: 1340px;
  padding: 0 47px 31px;
  position: relative;
  width: calc(100% - 40px);
  z-index: 1;

  &::before,
  &::after {
    content: '';
    position: absolute;
    pointer-events: none;
  }
  &::before {
    background: linear-gradient(
          90deg,
          transparent,
          rgba(38, 245, 255, 0.9),
          transparent
        )
        top 22px center / 62% 1px no-repeat,
      linear-gradient(90deg, rgba(41, 223, 255, 0.82), transparent) top 22px
        left 22px / 58px 2px no-repeat,
      linear-gradient(270deg, rgba(41, 223, 255, 0.82), transparent) top 22px
        right 22px / 58px 2px no-repeat,
      linear-gradient(90deg, transparent, rgba(42, 214, 255, 0.72), transparent)
        bottom 18px center / 52% 2px no-repeat;
    inset: 0;
  }
  &::after {
    background: repeating-linear-gradient(
          90deg,
          transparent 0 10px,
          rgba(38, 190, 255, 0.34) 10px 11px,
          transparent 11px 17px
        )
        bottom 32px center / 70% 7px no-repeat,
      linear-gradient(90deg, transparent, rgba(46, 233, 255, 0.76), transparent)
        bottom 28px center / 58% 1px no-repeat;
    inset: 0;
  }
}

.board-fullscreen-toggle {
  align-items: center;
  background: rgba(4, 42, 112, 0.82);
  border: 1px solid rgba(80, 241, 255, 0.85);
  box-shadow: 0 0 10px rgba(36, 222, 255, 0.38),
    inset 0 0 10px rgba(42, 145, 255, 0.2);
  color: #78f8ff;
  cursor: pointer;
  display: inline-flex;
  font-size: 19px;
  height: 32px;
  justify-content: center;
  padding: 0;
  position: absolute;
  right: 18px;
  top: 17px;
  transition: background-color 0.18s ease, box-shadow 0.18s ease;
  width: 32px;
  z-index: 2;
}
.board-fullscreen-toggle:hover,
.board-fullscreen-toggle:focus-visible {
  background: rgba(12, 101, 176, 0.9);
  box-shadow: 0 0 14px rgba(36, 240, 255, 0.82),
    inset 0 0 10px rgba(42, 145, 255, 0.32);
  outline: none;
}
.board-heading {
  height: 112px;
  padding-top: 18px;
  position: relative;
  text-align: center;
  z-index: 1;
}
.board-heading::before,
.board-heading::after {
  background: linear-gradient(
    90deg,
    transparent,
    rgba(47, 220, 255, 0.8),
    transparent
  );
  content: '';
  height: 1px;
  position: absolute;
  top: 75px;
  width: 29%;
}
.board-heading::before {
  left: 0;
}
.board-heading::after {
  right: 0;
}
.heading-kicker {
  color: #63e8ff;
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
  font-size: 34px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.08;
  margin: 0;
  position: relative;
  text-shadow: 0 0 3px rgba(35, 222, 255, 0.75),
    0 0 7px rgba(18, 115, 255, 0.28);
  z-index: 1;
}
.board-heading h2 {
  color: #ffe782;
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  margin: 3px 0 0;
  position: relative;
  z-index: 1;
}
.stat-period {
  color: #d6e9ff;
  font-family: Arial, 'Microsoft YaHei', sans-serif;
  font-size: 16px;
  line-height: 1;
  margin: 20px 0 0;
  position: relative;
  z-index: 1;
}

.summary-panel {
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(6, 46, 118, 0.76),
    rgba(16, 133, 194, 0.34),
    rgba(6, 46, 118, 0.76)
  );
  border: 1px solid #35eaff;
  box-shadow: 0 0 15px rgba(23, 200, 255, 0.34),
    inset 0 0 16px rgba(28, 199, 255, 0.22);
  clip-path: polygon(
    1.8% 0,
    98.2% 0,
    100% 28%,
    100% 72%,
    98.2% 100%,
    1.8% 100%,
    0 72%,
    0 28%
  );
  display: flex;
  height: 50px;
  justify-content: center;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  z-index: 1;
}
.summary-panel span {
  color: #f9fcff;
  font-size: 18px;
  font-weight: 700;
  margin-left: 20px;
  white-space: nowrap;
}
.summary-panel span:first-child {
  margin-left: 0;
}
.summary-panel strong {
  color: #ffe94d;
  font-size: 21px;
  margin: 0 2px;
  text-shadow: 0 0 6px rgba(255, 232, 75, 0.35);
}
.summary-panel sup {
  font-size: 10px;
}

.card-grid {
  display: grid;
  gap: 18px 22px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 25px;
  position: relative;
  z-index: 1;
}
.data-card {
  background: radial-gradient(
      ellipse at 50% 48%,
      rgba(28, 152, 235, 0.2),
      transparent 58%
    ),
    radial-gradient(rgba(102, 222, 255, 0.075) 0.4px, transparent 0.7px),
    repeating-linear-gradient(
      0deg,
      transparent 0 31px,
      rgba(76, 208, 255, 0.065) 32px 33px,
      transparent 34px 64px
    ),
    linear-gradient(
      115deg,
      rgba(2, 26, 87, 0.98),
      rgba(4, 53, 126, 0.91) 50%,
      rgba(2, 24, 78, 0.98)
    );
  background-size: auto, 11px 11px, auto, auto;
  border: 1px solid #39eaff;
  box-shadow: 0 0 10px rgba(23, 213, 255, 0.35),
    inset 0 0 20px rgba(25, 158, 255, 0.22);
  box-sizing: border-box;
  clip-path: polygon(
    4.5% 0,
    95.5% 0,
    100% 11%,
    100% 89%,
    95.5% 100%,
    4.5% 100%,
    0 89%,
    0 11%
  );
  min-height: 180px;
  padding: 18px 25px 16px 30px;
  position: relative;
}
.data-card::before {
  border: 1px solid rgba(107, 249, 255, 0.38);
  clip-path: polygon(
    4% 0,
    96% 0,
    100% 9%,
    100% 91%,
    96% 100%,
    4% 100%,
    0 91%,
    0 9%
  );
  content: '';
  inset: 5px;
  pointer-events: none;
  position: absolute;
}
.data-card::after {
  background: linear-gradient(90deg, #56faff 0 28px, transparent 28px 100%) top
      left / 42% 3px no-repeat,
    linear-gradient(270deg, #56faff 0 28px, transparent 28px 100%) top right /
      42% 3px no-repeat,
    linear-gradient(90deg, #3ce3ff 0 44px, transparent 44px 100%) bottom left /
      34% 1px no-repeat,
    linear-gradient(270deg, #3ce3ff 0 44px, transparent 44px 100%) bottom right /
      34% 1px no-repeat;
  box-shadow: 0 0 8px rgba(35, 240, 255, 0.9);
  content: '';
  left: 18px;
  pointer-events: none;
  position: absolute;
  right: 18px;
  bottom: 10px;
  top: 10px;
}
.card-title {
  align-items: center;
  display: flex;
  margin-bottom: 13px;
  position: relative;
  z-index: 1;
}
.card-number {
  align-items: center;
  background: rgba(1, 63, 137, 0.9);
  border: 1px solid #43f6ff;
  border-radius: 50%;
  box-shadow: 0 0 9px rgba(63, 246, 255, 0.65);
  color: #fff;
  display: inline-flex;
  font-family: Arial, sans-serif;
  font-size: 19px;
  font-weight: 700;
  height: 31px;
  justify-content: center;
  width: 31px;
}
.card-title h3 {
  color: #6dffff;
  font-size: 21px;
  line-height: 1;
  margin: 0 0 0 12px;
  text-shadow: 0 0 8px rgba(54, 235, 255, 0.7);
}
.card-body {
  display: flex;
  min-height: 92px;
  position: relative;
  z-index: 1;
}
.data-list {
  display: grid;
  flex: 1;
  gap: 7px 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  list-style: none;
  margin: 0;
  min-width: 0;
  padding: 0;
}
.data-list li {
  color: #f7fdff;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.5;
  min-width: 0;
  white-space: nowrap;
}
.data-list li.is-wide {
  grid-column: 1 / -1;
}
.data-list li::before {
  color: #4df6ff;
  content: '•';
  font-size: 17px;
  margin-right: 8px;
  vertical-align: -1px;
}
.data-list ::v-deep b {
  color: #fff165;
  font-weight: 800;
  margin: 0 1px;
}

@media screen and (max-width: 1200px) {
  .board-shell {
    padding: 0 24px 25px;
    width: calc(100% - 28px);
  }
  .board-heading {
    height: 96px;
    padding-top: 15px;
  }
  .heading-kicker {
    font-size: 28px;
  }
  .summary-panel {
    height: 46px;
    padding: 0 16px;
  }
  .summary-panel span {
    font-size: 15px;
    margin-left: 8px;
  }
  .summary-panel strong {
    font-size: 18px;
  }
  .card-grid {
    gap: 14px;
    margin-top: 20px;
  }
  .data-card {
    min-height: 142px;
    padding: 15px 18px 13px 21px;
  }
  .data-card::after {
    left: 14px;
    right: 14px;
  }
  .card-title {
    margin-bottom: 8px;
  }
  .card-number {
    font-size: 16px;
    height: 27px;
    width: 27px;
  }
  .card-title h3 {
    font-size: 18px;
    margin-left: 9px;
  }
  .card-body {
    min-height: 78px;
  }
  .data-list li {
    font-size: 13px;
    line-height: 1.55;
  }
  .data-list {
    grid-template-columns: 1fr;
  }
  .data-list li::before {
    font-size: 14px;
    margin-right: 5px;
  }
}

.mobile-content .data-board {
  min-width: 0;
  padding: 10px 0 18px;
}
.mobile-content .board-fullscreen-toggle {
  display: none;
}
.mobile-content .board-shell {
  padding: 0 13px 20px;
  width: calc(100% - 20px);
}
.mobile-content .board-heading {
  height: auto;
  padding: 13px 0 17px;
}
.mobile-content .heading-kicker {
  font-size: 18px;
}
.mobile-content .board-heading h2 {
  font-size: 12px;
}
.mobile-content .stat-period {
  font-size: 10px;
}
.mobile-content .summary-panel {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 5px 2px;
  height: auto;
  padding: 8px 12px;
  text-align: center;
}
.mobile-content .summary-panel span {
  font-size: 10px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
.mobile-content .summary-panel span + span::before {
  content: none;
}
.mobile-content .summary-panel strong {
  font-size: 12px;
  margin: 0 1px;
}
.mobile-content .card-grid {
  gap: 12px;
  grid-template-columns: 1fr;
  margin-top: 16px;
}
.mobile-content .data-card {
  min-height: 143px;
  padding: 15px 20px;
}
.mobile-content .data-list {
  grid-template-columns: 1fr;
}
.mobile-content .card-title {
  margin-bottom: 8px;
}
.mobile-content .card-number {
  font-size: 15px;
  height: 26px;
  width: 26px;
}
.mobile-content .card-title h3 {
  font-size: 18px;
}
.mobile-content .data-list li {
  font-size: 12px;
}
</style>
